import { BulkPropertyDataIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_BULK_PROPERTY_DATA: AppConfig = {
  name: 'Bulk Property Data',
  applicationKey: 'bulk-data',
  type: 'product',
  appSlugForEngagement: AppSlugs.BulkPropertyData,
  rootPath: `/bulk-property-data`,
  Icon: BulkPropertyDataIcon,
  descriptionLong:
    'Bulk property data by state or national, delivered monthly.',
  descriptionShort: 'Bulk property data',
};
